<template>
    <div>
        <b-loading :active.sync="isSaving" :can-cancel="false"></b-loading>

        <ErrorMessages :errors="errors"></ErrorMessages>

        <div class="top-spacer-30">
            <div v-for="(file, index) in uploadedFiles" :key="index" class="part">
                <div :class="{ creative_margin: uploadType === 'creative_pack' && creativeTypes.indexOf('Video') >= 0 && file.creative_type === 'Interstitial' }">
                    <div class="creative_image_container">
                        <b v-if="uploadType === 'creative_pack' && creativeTypes.indexOf('Video') >= 0 && file.creative_type === 'Interstitial'">{{$t('companion')}}: </b>
                        <b v-else>{{file.creative_type}}: </b>
                        <b v-if="file.width > 0 && file.height > 0">{{ file.width }}X{{ file.height }}: </b>
                        {{ file.file_name }}
                        <b-button class="is-small left-spacer-10" @click="deleteUploadedFile(index)">{{$t('remove')}}</b-button>
                        <div class="top-spacer-5">
                            <b>{{$t('language')}}:</b>
                            <select v-model="file.language" class="left-spacer-10">
                                <option v-for="language in languages"
                                        :value="language.code"
                                        :key="language.code">
                                    {{language.name}}
                                </option>
                            </select>
                        </div>
                        <div class="top-spacer-5 bottom-spacer-20">
                            <div>
                                <b>{{$t('schedule')}}:</b>
                                <select v-model="file.group_id" class="left-spacer-10 width-150">
                                    <option v-for="group in schedule_groups_with_blank"
                                            :value="group.id"
                                            :key="group.id">
                                        {{group.group_name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="cell">
                            <video v-if="file.file_type === 'video'" width="320" controls><source :src="file.url" type="video/mp4"></video>
                            <img v-else-if="file.file_type === 'html'" width="100" src="images/playable.jpg" alt="Playable" class="creative_image"/>
                            <img v-else-if="file.file_type === 'image'" :src="file.url" class="creative_image"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="creativeTypes.indexOf('Video') >= 0 && creativeTypes.indexOf('Interstitial') >= 0" class="bottom-spacer-20">
            {{$t('creative_pack_help_text')}}
        </div>

        <div v-if="uploadedFiles.length > 1" class="inline">
            <div>
                <b-field>
                    <template v-slot:label>
                        {{$t('language')}}
                        <b-tooltip type="is-dark" :label="$t('creative_language_tooltip')" multilined>
                            <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                        </b-tooltip>
                    </template>
                    <div class="control inline">
                        <span class="select">
                            <select v-model="global_language">
                                <option v-for="language in languages"
                                        :value="language.code"
                                        :key="language.code">
                                    {{language.name}}
                                </option>
                            </select>
                        </span>
                    </div>
                </b-field>
            </div>

            <div class="left-spacer-20">
                <b-field>
                    <template v-slot:label>
                        {{$t('schedule')}}
                        <b-tooltip type="is-dark" :label="$t('creative_schedule_tooltip')" multilined>
                            <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                        </b-tooltip>
                    </template>
                    <div class="control inline">
                        <span class="select">
                            <select v-model="global_group_id" class="width-150">
                                <option v-for="group in schedule_groups_with_blank"
                                        :value="group.id"
                                        :key="group.id">
                                    {{group.group_name}}
                                </option>
                            </select>
                        </span>
                    </div>
                </b-field>
            </div>

            <div class="left-spacer-20">
                <b-field>
                    <template v-slot:label>
                        &nbsp;
                    </template>
                    <div class="control">
                        <b-button @click="applyGlobalFields()">{{$t('apply_to_all_creatives')}}</b-button>
                    </div>
                </b-field>
            </div>
        </div>

        <div>
            <button v-if="uploadedFiles.length > 0" class="ds-button button-small w-button top-spacer-20" v-on:click="submit">
                {{$t('submit')}}
            </button>
        </div>

        <div>
            <button v-if="uploadedFiles.length === 0 && removedFiles.length > 0" class="ds-button button-small w-button top-spacer-20" v-on:click="submit">
                {{$t('clear_pending_creatives')}}
            </button>
        </div>
    </div>
</template>

<style>
    .creative_image_container {
        top: 30px;
        margin-bottom: 30px;
    }
    .inline {
        display: inline-flex;
    }
    .left-spacer-10 {
        margin-left: 10px;
    }
    .left-spacer-20 {
        margin-left: 20px;
    }
    .bottom-spacer-20 {
        margin-bottom: 20px;
    }
    .top-spacer-5 {
        margin-top: 5px;
    }
    .top-spacer-20 {
        margin-top: 20px;
    }
    .top-spacer-30 {
        margin-top: 30px;
    }
    .width-150 {
        min-width: 150px;
    }
    .creative_margin {
        margin-left: 40px;
    }
    img.creative_image {
        max-width: 320px;
        max-height: 320px;
    }
</style>

<script>
    import ErrorMessages from "../components/ErrorMessages";
    import common from '../common'
    import session from '../session'

    session.checkSession();

    const offerId = session.getParam('offer_id');

    const model = {
        isSaving: false,
        offer_id: offerId,
        languages: [],
        global_language: null,
        global_group_id: null,
        schedule_groups_with_blank: [],
        errors: [],
        removedFiles: [],
    };

    function getLanguagesSuccessHandler(responseData) {
        model.languages.splice(0, model.languages.length);
        for (let i = 0; i < responseData.length; i++) {
            model.languages.push(responseData[i]);
        }
    }

    function getLanguagesErrorHandler() {
        model.languages = [];
    }

    session.get('languages', getLanguagesSuccessHandler, getLanguagesErrorHandler, []);

    function getScheduleGroupsSuccessHandler(responseData) {
        common.clearArray(model.schedule_groups_with_blank);
        model.schedule_groups_with_blank.push({
            id: null,
            group_name: " ",
            schedules: []
        });
        for (let i = 0; i < responseData.length; i++) {
            const group = responseData[i];
            for (let j = 0; j < group.schedules.length; j++) {
                group.schedules[j].dates[0] = new Date(Date.parse(group.schedules[j].dates[0]));
                group.schedules[j].dates[1] = new Date(Date.parse(group.schedules[j].dates[1]));
            }
            model.schedule_groups_with_blank.push(group);
        }
    }

    function getScheduleGroupsErrorHandler() {
        common.clearArray(model.schedule_groups_with_blank);
        model.schedule_groups_with_blank.push({
            id: null,
            group_name: " ",
            schedules: []
        });
    }

    session.get('creative_schedule_groups', getScheduleGroupsSuccessHandler, getScheduleGroupsErrorHandler, []);

    export default {
        props: {
            uploadType: String,
            uploadedFiles: Array,
        },

        components: {
            ErrorMessages,
        },

        created() {
            if (!offerId) {
                session.navigateToPage('dashboard.html');
            }
        },

        data() {
            return model;
        },

        computed: {
            creativeTypes: function() {
                return common.unique(this.uploadedFiles.map(c => c.creative_type));
            }
        },

        methods: {
            applyGlobalFields() {
                for (let i = 0; i < this.uploadedFiles.length; i++) {
                    this.uploadedFiles[i].language = this.global_language;
                    this.uploadedFiles[i].group_id = this.global_group_id;
                }
                this.global_language = null;
                this.global_group_id = null;
            },

            deleteUploadedFile(index) {
                let removed = this.uploadedFiles.splice(index, 1);
                this.removedFiles.push(...removed);
            },

            submit: function () {
                function submitSuccessHandler() {
                    model.isSaving = false;
                    session.navigateToPage('campaign.html?offer_id=' + offerId + '&scroll=true');
                }

                function errorHandler() {
                    model.isSaving = false;
                }

                const data = {
                    upload_type: this.uploadType,
                    creatives: this.uploadedFiles,
                    removed: this.removedFiles,
                    language: model.language,
                    group_id: model.group_id
                };
                model.isSaving = true;
                session.post('add_creatives/' + model.offer_id, data, submitSuccessHandler, errorHandler, model.errors)
            }
        }
    }
</script>
